module.exports = __webpack_public_path__ + "img/ab-desktop-default.0b842da7.png";